// This list needs to be maintained to account for all timezones in our db that are deprecated in IANA
export const DEPRECATED_TIMEZONE_MAP = {
  'Brazil/DeNoronha': 'America/Noronha',
  'US/Samoa': 'Pacific/Pago_Pago',
  'PST8PDT': 'America/Los_Angeles',
  'CST6CDT': 'America/Chicago',
  'HST': 'Pacific/Honolulu',
  'MST': 'America/Phoenix',
};

export type DeprecatedTimezone = keyof typeof DEPRECATED_TIMEZONE_MAP;
